import React, { useState, useCallback, useEffect } from "react";
import { FaRegSquarePlus } from "react-icons/fa6";
import { AiOutlineCloseCircle } from "react-icons/ai";
import LoadingImage from "./assets/Loading.gif";
import { ToastContainer, toast } from "react-toastify";
import HTTP_BASE_URL from "../constants/HttpConstants";
import { useNavigate } from "react-router-dom";

const toastrOptions = {
  position: "top-center",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const BillingGst = ({ close, id }) => {
  const customertoken = localStorage.getItem("customertoken");
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [closePopup, setClosePopup] = useState();
  const [suggestions, setSuggestions] = useState({
    billing_company_name: [],
  });
  const [gstInputs, setGstInputs] = useState({});
  // const [bookingDetails, setBookingDetails] = useState()
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [result, setResult] = useState({
    addressType1: [],
    addressType2: [],
    addressType3: [],
  });

  const getFullDetails = useCallback(() => {
    const myHeaders = new Headers();
    myHeaders.append("access-token", "508b1430-68f0-4b2f-9003-3c2a0eb2a54a");
    myHeaders.append("customertoken", customertoken);
    const formdata = new FormData();
    formdata.append("id", id);
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(HTTP_BASE_URL + "getBookingdetails", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.code === 0) {
          const bookingDetails = result.data;
          setGstInputs((prevState) => ({
            ...prevState,
            gstno: bookingDetails
              ? bookingDetails?.gstno === "null" || !bookingDetails?.gstno
                ? ""
                : bookingDetails?.gstno
              : "",
            bill_status: bookingDetails
              ? bookingDetails?.bill_status === "null" ||
                !bookingDetails?.bill_status
                ? ""
                : bookingDetails?.bill_status
              : "",
            billing_company_name: bookingDetails
              ? bookingDetails?.company_name === "null" ||
                !bookingDetails?.company_name
                ? ""
                : bookingDetails?.company_name
              : "",
            payment_type: bookingDetails
              ? bookingDetails?.payment_type === "null" ||
                !bookingDetails?.payment_type
                ? ""
                : bookingDetails?.payment_type
              : "",
          }));
          //  console.log('billingDetails', bookingDetails);
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, [id, customertoken, navigate]);

  const getAddressList = useCallback(async () => {
    const fullData = new FormData();
    fullData.append("bookingid", id);
    try {
      await fetch(HTTP_BASE_URL + "getAddressList", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
          customertoken: customertoken,
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            // setInputValues(result.data)
            const addressType1 = result.data.filter(
              (item) => item.address_type === 1
            );
            const addressType2 = result.data.filter(
              (item) => item.address_type === 2
            );
            const addressType3 = result.data.filter(
              (item) => item.address_type === 3
            );
            setResult({ addressType1, addressType2, addressType3 });
            if (addressType3.length > 0) {
              setGstInputs((prevState) => ({
                ...prevState,
                billing_company_name: addressType3[0].company_name || "",
                billing_address_line1: addressType3[0].address_line1 || "",
                billing_address_line2: addressType3[0].address_line2 || "",
                billing_city: addressType3[0].city || "",
                billing_state: addressType3[0].state || "",
                billing_country: addressType3[0].country || "",
                billing_pincode: addressType3[0].pincode || "",
                billing_landmark: addressType3[0].landmark || "",
              }));
            } else {
              console.warn("No Billing Address.");
            }
          } else {
            navigate("/");
          }
        });
    } catch (error) {
      // setError(error); // Store any errors in the state
      console.error("Error:", error);
    }
  }, [id, customertoken, navigate]);

  const tokenExpiry = useCallback(() => {
    if (!customertoken) {
      // Step 1: Clear storage
      localStorage.clear(); // or sessionStorage.clear();
      // Step 2: Redirect to login or home page
      navigate("/", { replace: true });
      // Step 3: Prevent going back to the previous page
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = () => {
        window.history.pushState(null, "", window.location.href);
      };
    }
  }, [customertoken, navigate]);

  useEffect(() => {
    getFullDetails();
    getAddressList();
    tokenExpiry();
  }, [getAddressList, getFullDetails, tokenExpiry]);

  const handleGetAddress = (event) => {
    const { name, value, checked, type } = event.target;

    if (value === "1") {
      const { addressType1 } = result; // Extract addressType1 from result

      if (addressType1.length > 0) {
        const selectedAddress = addressType1[0];
        setGstInputs({
          ...gstInputs, // Preserve other fields
          billing_address_line1: selectedAddress.address_line1 || "",
          billing_address_line2: selectedAddress.address_line2 || "",
          billing_city: selectedAddress.city || "",
          billing_state: selectedAddress.state || "",
          billing_country: selectedAddress.country || "",
          billing_pincode: selectedAddress.pincode || "",
          billing_landmark: selectedAddress.landmark || "",
        });
      }
    } else if (value === "2") {
      const { addressType2 } = result; // Extract addressType2 from result

      if (addressType2.length > 0) {
        const selectedAddress = addressType2[0];
        setGstInputs({
          ...gstInputs, // Preserve other fields
          billing_address_line1: selectedAddress.address_line1 || "",
          billing_address_line2: selectedAddress.address_line2 || "",
          billing_city: selectedAddress.city || "",
          billing_state: selectedAddress.state || "",
          billing_country: selectedAddress.country || "",
          billing_pincode: selectedAddress.pincode || "",
          billing_landmark: selectedAddress.landmark || "",
        });
      }
    }

    // Update other input states as needed
    setGstInputs((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChange = (event) => {
    const { name, value, checked, type } = event.target;
    setGstInputs({
      ...gstInputs,
      [name]: type === "checkbox" ? checked : value,
    });
    const error = validateField(name, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  //  get company list

  const handleCompanyListKeyPress = (event) => {
    const query = event.target.value;
    setGstInputs((prev) => ({ ...prev, billing_company_name: query })); // Update input value dynamically

    fetch(HTTP_BASE_URL + "getCompanyList", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        customertoken: customertoken,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.code === 0) {
          if (result.data) {
            const filteredNames = [
              ...new Set(
                result.data
                  .filter((item) =>
                    item.name.toLowerCase().includes(query.toLowerCase())
                  )
                  .map((item) => item.name)
              ),
            ];
            setSuggestions((prev) => ({
              ...prev,
              billing_company_name:
                filteredNames.length > 0 ? filteredNames : false,
            }));
          }
        }
      })
      .catch((error) => {
        console.error("Error fetching company list:", error);
        setSuggestions((prev) => ({ ...prev, billing_company_name: [] })); // Clear suggestions on error
      });
  };

  const handleSuggestionClick = (field, value) => {
    setGstInputs((prev) => ({ ...prev, [field]: value }));
    setSuggestions((prev) => ({ ...prev, [field]: [] }));
  };

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "gstno":
        if (!value) {
          error = "";
        } else if (!/^[0-9A-Za-z\s]{12,15}$/.test(value)) {
          error =
            "Please enter a valid number (12-15 alphanumeric characters).";
        }
        break;
      case "billing_address_line1":
      case "billing_address_line2":
        if (!value) {
          error = "This field is required.";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z0-9\s,-]+$/.test(value)) {
          error =
            "Only letters, numbers, spaces, hyphens, and commas are allowed.";
        }
        break;
      case "billing_city":
      case "billing_state":
      case "billing_country":
        if (!value) {
          error = "This field is required.";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
          error = "Only letters, spaces, and hyphens are allowed.";
        }
        break;
      case "billing_company_name":
        if (!value) {
          error = "";
        } else if (value.length < 2) {
          error = "Please enter at least 2 characters.";
          // } else if (!/^[a-zA-Z\s\.\-]+$/.test(value)) {
          //     error = "Please enter letters, spaces, hyphens, and periods only.";
          // }
        } else if (!/^[a-zA-Z\s-]+$/.test(value)) {
          error = "Only letters, spaces, and hyphens are allowed.";
        }
        break;
      case "billing_pincode":
        if (!value) {
          error = "";
        } else if (!/^[0-9]{6}$/.test(value)) {
          error = "Please enter exactly 6 digits.";
        }
        break;
      case "billing_landmark":
        if (!value) {
          error = "";
        } else if (!/^[a-zA-Z0-9\s,-]+$/.test(value)) {
          error =
            "Only letters, numbers, spaces, hyphens, and commas are allowed.";
        }
        break;
      default:
        break;
    }
    return error;
  };

  const gstSubmit = async (event) => {
    event.preventDefault();
    const newErrors = {};

    // Validate fields and collect errors
    Object.keys(gstInputs).forEach((fieldName) => {
      const error = validateField(fieldName, gstInputs[fieldName]);
      if (error) newErrors[fieldName] = error;
    });

    if (Object.keys(newErrors).length > 0) {
      // alert('Please fill in all fields correctly');
      toast.warning("Please ensure all fields are filled in correctly.", {
        toastrOptions,
      });
      return;
    }
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setIsSubmitting(true); // Show loading spinner

      // Handle payment type-specific logic
      let updatedValues = { ...gstInputs };
      if (gstInputs.payment_type === "1") {
        updatedValues.billing_company_name = "";
        updatedValues.bill_status = "0";
      }
      // Create FormData for submission
      const formData = new FormData();
      formData.append("bookingid", id);
      Object.keys(updatedValues).forEach((key) => {
        formData.append(key, updatedValues[key]);
      });
      // console.log('formData', formData)
      try {
        // Simulate delay for spinner demo
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Submit the form data via API
        const response = await fetch(HTTP_BASE_URL + "saveBillingAddress", {
          method: "post",
          headers: {
            "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
            customertoken: customertoken,
          },
          body: formData,
        });
        const result = await response.json();

        // Handle API response
        if (result.code === 0) {
          //  console.log("Form submitted successfully:", result);
          setIsSubmitted(true);
          toast.success("Billing details saved successfully!", {
            toastrOptions,
          });
          setTimeout(function () {
            window.location.reload();
            setClosePopup(close);
            // handleReload()
          }, 1500);
        } else if (result.code === 1) {
          toast.error("Please complete all required fields correctly.", {
            toastrOptions,
          });
        }
      } catch (error) {
        console.error("Submission failed:", error);
        // alert("An error occurred. Please try again.");
      } finally {
        setIsSubmitting(false); // Hide loading spinner
      }
    }
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="fromModel">
        <div className="billingModal-content">
          <div className="div">
            <div className="gstModel-header">
              <p className="addGst">
                <FaRegSquarePlus /> Add GST No, Billing Address
              </p>
              <div className="btn-close" onClick={() => close(false)}>
                <AiOutlineCloseCircle />
              </div>
            </div>
            <div className="modal-body">
              <form onSubmit={gstSubmit} autoComplete="off">
                {/* <input type="hidden" name='bookingid' value={gstInputs.bookingid || ''} /> */}
                <div className="row p-0 m-0">
                  <div className="col form-col col-md-6 payment-col col-12">
                    <p className="form-label">
                      {" "}
                      Payment Type <span className="req-span">*</span>
                    </p>
                    <div className="form-check form-check-inline">
                      <label className="form-check-label" htmlFor="selfPayment">
                        <input
                          className="form-check-input"
                          value="1"
                          name="payment_type"
                          id="selfPayment"
                          type="radio"
                          checked={gstInputs.payment_type === "1"}
                          onChange={handleInputChange}
                        />
                        Self-Payment
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <label
                        className="form-check-label"
                        htmlFor="companyPayment"
                      >
                        <input
                          className="form-check-input"
                          checked={gstInputs.payment_type === "2"}
                          onChange={handleInputChange}
                          value="2"
                          name="payment_type"
                          id="companyPayment"
                          type="radio"
                        />
                        Company Pay
                      </label>
                    </div>
                  </div>
                  {gstInputs.payment_type === "2" && (
                    <div className="col form-col col-md-6  col-12">
                      <label
                        htmlFor="billing_company_name"
                        className="form-label"
                      >
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="billing_company_name"
                        name="billing_company_name"
                        value={gstInputs.billing_company_name || ""}
                        onInput={handleCompanyListKeyPress}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="XYZ Company"
                      />
                      {suggestions.billing_company_name &&
                        suggestions.billing_company_name.length > 0 && (
                          <ul className="suggestion-list">
                            {suggestions.billing_company_name.map((name) => (
                              <li
                                key={name}
                                onClick={() =>
                                  handleSuggestionClick(
                                    "billing_company_name",
                                    name
                                  )
                                }
                              >
                                {name}
                              </li>
                            ))}
                          </ul>
                        )}
                      <div className="form-check form-check-inline">
                        <label className="form-check-label" htmlFor="toBePaid">
                          <input
                            className="form-check-input"
                            value="1"
                            checked={gstInputs.bill_status === "1"}
                            onChange={handleInputChange}
                            name="bill_status"
                            id="toBePaid"
                            type="radio"
                          />
                          To be paid
                        </label>
                      </div>
                      <div className="form-check form-check-inline">
                        <label
                          className="form-check-label"
                          htmlFor="companyBill"
                        >
                          <input
                            className="form-check-input"
                            value="2"
                            checked={gstInputs.bill_status === "2"}
                            onChange={handleInputChange}
                            name="bill_status"
                            id="companyBill"
                            type="radio"
                          />
                          Company Pay
                        </label>
                      </div>
                      {errors.billing_company_name && (
                        <p className="text-para red">
                          {errors.billing_company_name}
                        </p>
                      )}
                    </div>
                  )}
                  <div className="form-col col-12 col-md-6">
                    <label htmlFor="gstno" className="form-label">
                      GST No
                    </label>
                    <input
                      type="text"
                      id="gstno"
                      onInput={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      onChange={handleInputChange}
                      value={gstInputs.gstno || ""}
                      name="gstno"
                      className="form-control"
                      placeholder="Eg: ESPS1524EPSD"
                    />
                    {errors.gstno && (
                      <p className="text-para red">{errors.gstno}</p>
                    )}
                  </div>
                  <div className="col form-col col-md-12 payment-col col-12">
                    <p className="form-label"> Billing Address</p>
                    <div className="form-check form-check-inline">
                      <label
                        className="form-check-label"
                        htmlFor="senderAddress"
                      >
                        <input
                          className="form-check-input"
                          value="1"
                          name="billingAddress"
                          id="senderAddress"
                          type="radio"
                          // checked={gstInputs.address_type === 1}
                          onChange={handleGetAddress}
                        />
                        Same As Sender Address
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <label
                        className="form-check-label"
                        htmlFor="receiverAddress"
                      >
                        <input
                          className="form-check-input"
                          // checked={gstInputs.address_type === 2}
                          onChange={handleGetAddress}
                          value="2"
                          name="billingAddress"
                          id="receiverAddress"
                          type="radio"
                        />
                        Same As Receiver Address
                      </label>
                    </div>
                  </div>
                  <div className="form-col  col-12 col-md-6">
                    <label
                      htmlFor="billing_address_line1"
                      className="form-label"
                    >
                      Billing Address 1 <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="billing_address_line1"
                      onChange={handleInputChange}
                      value={gstInputs.billing_address_line1 || ""}
                      name="billing_address_line1"
                      className="form-control"
                      placeholder="Eg: H3, Main Road"
                    />
                    {errors.billing_address_line1 && (
                      <p className="text-para red">
                        {errors.billing_address_line1}
                      </p>
                    )}
                  </div>
                  <div className="form-col col-12 col-md-6">
                    <label
                      htmlFor="billing_address_line2"
                      className="form-label"
                    >
                      Billing Address 2 <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="billing_address_line2"
                      onChange={handleInputChange}
                      value={gstInputs.billing_address_line2 || ""}
                      name="billing_address_line2"
                      className="form-control"
                      placeholder="Eg: Billing Address 2"
                    />
                    {errors.billing_address_line2 && (
                      <p className="text-para red">
                        {errors.billing_address_line2}
                      </p>
                    )}
                  </div>
                  <div className="form-col  col-12 col-md-6">
                    <label htmlFor="billing_landmark" className="form-label">
                      Landmark
                    </label>
                    <input
                      type="text"
                      id="billing_landmark"
                      onChange={handleInputChange}
                      value={gstInputs.billing_landmark || ""}
                      name="billing_landmark"
                      className="form-control"
                      placeholder=""
                    />
                    {errors.billing_landmark && (
                      <p className="text-para red">{errors.billing_landmark}</p>
                    )}
                  </div>
                  <div className="form-col  col-12 col-md-6">
                    <label htmlFor="billing_city" className="form-label">
                      City <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="billing_city"
                      onChange={handleInputChange}
                      value={gstInputs.billing_city || ""}
                      name="billing_city"
                      className="form-control"
                      placeholder="Eg: Jam Nagar"
                    />
                    {errors.billing_city && (
                      <p className="text-para red">{errors.billing_city}</p>
                    )}
                  </div>
                  <div className="form-col  col-12 col-md-6">
                    <label htmlFor="billing_state" className="form-label">
                      State <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="billing_state"
                      onChange={handleInputChange}
                      value={gstInputs.billing_state || ""}
                      name="billing_state"
                      className="form-control"
                      placeholder="Eg: Delhi"
                    />
                    {errors.billing_state && (
                      <p className="text-para red">{errors.billing_state}</p>
                    )}
                  </div>
                  <div className="form-col  col-12 col-md-6">
                    <label htmlFor="billing_country" className="form-label">
                      Country <span className="req-span">*</span>
                    </label>
                    <input
                      type="text"
                      id="billing_country"
                      onChange={handleInputChange}
                      value={gstInputs.billing_country || ""}
                      name="billing_country"
                      className="form-control"
                      placeholder="Eg: India"
                    />
                    {errors.billing_country && (
                      <p className="text-para red">{errors.billing_country}</p>
                    )}
                  </div>
                  <div className="form-col  col-12 col-md-6">
                    <label htmlFor="billing_pincode" className="form-label">
                      Pincode
                    </label>
                    <input
                      type="text"
                      id="billing_pincode"
                      onChange={handleInputChange}
                      value={gstInputs.billing_pincode || ""}
                      name="billing_pincode"
                      className="form-control"
                      placeholder=""
                    />
                    {errors.billing_pincode && (
                      <p className="text-para red">{errors.billing_pincode}</p>
                    )}
                  </div>
                </div>
                <div className="modal-footer pt-lg-2rm pt-4 text-center">
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isSubmitting || isSubmitted}
                  >
                    {isSubmitting
                      ? "Submitting..."
                      : isSubmitted
                      ? "Submitted"
                      : "Submit"}
                    <span className="sub-loading">
                      {isSubmitting && (
                        <img
                          src={LoadingImage}
                          alt="Progress indicator"
                          width={25}
                          height={25}
                          loading="eager"
                        />
                      )}
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillingGst;
